<template>
    <div class="container mt-4">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h3 class="fw-bold text-primary mb-0">
                <i class="fa fa-bullseye me-2"></i>
                {{ isEdit ? "Edit Target & Goal" : "Add Target & Goal" }}
            </h3>
            <button class="btn btn-outline-secondary btn-sm" @click="$router.go(-1)">
                <i class="bx bx-left-arrow-alt me-1"></i> Back
            </button>
        </div>

        <!-- Card -->
        <div class="card shadow-sm border-0">
            <div class="card-body">
                <form @submit.prevent="saveTarget" class="row form-group g-4">

                    <!-- Employee -->

                    <div class="col-md-4 mb-10">
                        <label>Employee</label>
                        <select v-model="form.userid" class="form-control form-cascade-control input-small" required>
                            <option disabled value="">Select Employee</option>
                            <option v-for="emp in employees" :key="emp.id" :value="emp.id">{{ emp.name }}</option>
                        </select>
                    </div>

                    <!-- Month -->
                    <div class="col-md-4 mb-10">
                        <label >Month</label>
                        <select v-model="form.month" class="form-control form-cascade-control input-small" required>
                            <option disabled value="">Select Month</option>
                            <option v-for="m in 12" :key="m" :value="m">
                                {{ monthName(m) }}
                            </option>
                        </select>
                    </div>

                    <!-- Year -->
                    <div class="col-md-4 mb-10">
                        <label >Year</label>
                        <input type="number" v-model="form.year" class="form-control form-cascade-control input-small" required min="2020" />
                    </div>

                    <!-- Sales -->
                    <div class="col-md-4 mb-10">
                        <label>Target Sales</label>
                        <input type="number" v-model="form.target_sales" class="form-control form-cascade-control input-small" required
                            placeholder="Enter sales target" />
                    </div>

                    <!-- Leads -->
                    <div class="col-md-4">
                        <label >Target Leads</label>
                        <input type="number" v-model="form.target_leads" class="form-control form-cascade-control input-small" required
                            placeholder="Enter leads target" />
                    </div>

                    <!-- Visits -->
                    <div class="col-md-4">
                        <label>Target Visits</label>
                        <input type="number" v-model="form.target_visits" class="form-control form-cascade-control input-small" required
                            min="0" placeholder="Enter visits target" />
                    </div>

                    <!-- Deliveries -->
                    <div class="col-md-4">
                        <label>Target Deliveries</label>
                        <input type="number" v-model="form.target_deliveries" class="form-control form-cascade-control input-small" required
                            min="0" placeholder="Enter deliveries target" />
                    </div>

                    <!-- Independent completed social-media tasks -->
                    <div class="col-md-4">
                        <label>Target Social Media Tasks</label>
                        <input type="number" v-model="form.target_social_media" class="form-control form-cascade-control input-small" required
                            min="0" max="999999999" step="1" placeholder="Completed social-media tasks" />
                    </div>

                    <!-- Collection -->
                    <div class="col-md-4">
                        <label >Target Collection</label>
                        <input type="number" v-model="form.target_collection" class="form-control form-cascade-control input-small"
                            placeholder="Enter collection target" />
                    </div>

                    <!-- Buttons -->
                    <div class="col-md-12 text-end mt-4">
                        <button type="submit" class="btn btn-primary px-4">
                            <i class="bx bx-save me-1"></i>
                            {{ isEdit ? "Update" : "Save" }}
                        </button>
                        <button type="button" class="btn btn-outline-secondary px-4 ms-2"
                            @click="$router.push('/target')">
                            <i class="bx bx-x me-1"></i> Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            form: {
                userid: "",
                month: "",
                year: new Date().getFullYear(),
                target_sales: "",
                target_leads: "",
                target_visits: "",
                target_deliveries: "",
                target_social_media: 0,
                target_collection: "",
            },
            isEdit: false,
        };
    },
    computed: {
       ...mapGetters(["employees"])
    },
    async mounted() {
        if(this.employees.length == 0){
            await this.$store.dispatch("fetchemployees");
        }

        // Check if editing
        if (this.$route.query.id) {
            this.isEdit = true;
            const { data } = await axios.post("/api/target/fetchbyadmin", { id: this.$route.query.id });
            if(data.data.length > 0){
                let target = data.data[0];
               this.form = { ...target, target_social_media: Number(target.target_social_media || 0) };
            }
        }
    },
    methods: {
        async saveTarget() {
            await axios.post("/api/target/createUpdate", this.form);
            alert(
                this.isEdit
                    ? "Target updated successfully!"
                    : "Target created successfully!"
            );
            this.$router.push("/target");
        },
        monthName(m) {
            return new Date(0, m - 1).toLocaleString("default", { month: "long" });
        },
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
}

.form-label {
    color: #333;
}

button {
    border-radius: 6px;
}

hr {
    border-top: 1px solid #ddd;
}

/* Responsive Styling */
@media (max-width: 778px) {
    .card-body {
        padding: 15px;
    }

    h3 {
        font-size: 1.3rem;
    }
}
</style>
